import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/index.scss';
import FormView from './components/FormView';
import ResponseView from './components/ResponseView';
import Header from './components/Header';
import Footer from './components/Footer';
import { LanguageProvider } from './contexts/LanguageContext';
import RequireAuth from './components/RequireAuth';
import AdminLogin from './components/AdminLogin';
const AdminLanguageIntros = React.lazy(() => import('./components/AdminLanguageIntros'));

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="app">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<FormView />} />
              <Route path="/response" element={<ResponseView />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin/language-intros"
                element={
                  <RequireAuth>
                    <Suspense fallback={<div style={{ padding: 16 }}>Ładowanie...</div>}> 
                      <AdminLanguageIntros />
                    </Suspense>
                  </RequireAuth>
                }
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
